import { useState, useEffect, useRef } from "react";
import { listenToRoom } from "../firebase/roomService";

// Listens to a Firebase room in real-time
// Returns { roomData, loading }
const useRoom = (roomCode) => {
  const [roomData, setRoomData] = useState(null);
  const [loading, setLoading] = useState(true);
  const unsubscribeRef = useRef(null);

  useEffect(() => {
    if (!roomCode) return;

    setLoading(true);

    const unsubscribe = listenToRoom(roomCode, (data) => {
      setRoomData(data);
      setLoading(false);
    });

    unsubscribeRef.current = unsubscribe;

    // Cleanup listener when component unmounts or roomCode changes
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
    };
  }, [roomCode]);

  return { roomData, loading };
};

export default useRoom;